let ctx;

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function blip({ from, to, peak, duration, type = "sine", delay = 0 }) {
  try {
    const audio = getCtx();
    const t = audio.currentTime + delay;
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(from, t);
    osc.frequency.exponentialRampToValueAtTime(to, t + duration * 0.6);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(peak, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
    osc.connect(gain).connect(audio.destination);
    osc.start(t);
    osc.stop(t + duration + 0.05);
  } catch { /* áudio indisponível */ }
}

export function playSendSound() {
  blip({ from: 480, to: 920, peak: 0.10, duration: 0.18 });
  blip({ from: 920, to: 1240, peak: 0.06, duration: 0.14, delay: 0.07 });
}

export function playReceiveSound() {
  blip({ from: 1180, to: 760, peak: 0.07, duration: 0.16 });
}
